import { combineReducers } from 'redux';
import authReducer from './authReducer';
import productReducer from './productReducer';
import categoryReducer from './categoryReducer';
import blogReducer from './blogReducer';
// import classReducer from './classReducer';
// import courseReducer from './courseReducer';
// import usersReducer from './usersReducer';
// import quizReducer from './quizReducer';
// import subscriptionsReducer from './subscriptionsReducer';

const rootReducer = combineReducers({
	auth: authReducer,
	products: productReducer,
	category: categoryReducer,
	blog: blogReducer,
	// course: courseReducer,
	// class: classReducer,
	// users: usersReducer,
	// quiz: quizReducer,
	// subscription: subscriptionsReducer,
});
export default rootReducer;
